var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.09,-2.37891 H -1.09375 V 4252 H 4253.09 V -2.37891",
    style: {
      fill: "#ee2f28",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 677.227,3623.89 c -56.903,0 -98.668,-20.22 -121.446,-59.46 h -1.289 v 213.82 h 248 v 117.64 H 422.98 v -483.32 h 131.512 v 19.06 c 0,50.6 22.824,78.43 63.254,78.43 44.309,0 62.063,-30.42 62.063,-77.24 v -207.47 c 0,-45.57 -16.465,-77.17 -60.774,-77.17 -49.355,0 -67.019,32.89 -67.019,83.47 V 3339.2 H 420.355 v -97.41 c 0,-130.29 51.883,-213.81 198.68,-213.81 145.508,0 204.942,77.16 204.942,196.11 v 210.02 c 0,135.38 -69.563,189.78 -146.75,189.78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2118.64,1164.83 c -281.07,0 -509.67,228.69 -509.67,509.73 0,281.08 228.6,509.74 509.67,509.74 281.1,0 509.76,-228.66 509.76,-509.74 0,-281.04 -228.66,-509.73 -509.76,-509.73 m 978.93,1477.39 h -528.73 c -3.61,0 -6.71,-2.99 -6.71,-6.74 v -175.7 c 0,-3.77 3.1,-6.76 6.71,-6.76 h 210.54 L 2545.61,2219.2 c -117.76,92.51 -265.92,147.88 -426.97,147.88 -381.8,0 -692.52,-310.66 -692.52,-692.52 0,-351.57 263.41,-642.52 603.15,-686.54 V 785.559 h -208.56 c -3.87,0 -6.81,-2.989 -6.81,-6.68 v -188.32 c 0,-3.75 2.94,-6.727 6.81,-6.727 h 208.56 V 384.59 c 0,-3.719 2.99,-6.719 6.71,-6.719 h 188.23 c 3.74,0 6.82,3 6.82,6.719 v 199.242 h 208.51 c 3.72,0 6.72,2.977 6.72,6.727 v 188.32 c 0,3.691 -3,6.68 -6.72,6.68 h -208.51 v 205.75 c 328.56,53.901 580.1,339.661 580.1,683.251 0,148.22 -46.91,285.57 -126.48,398.32 l 230.45,230.48 v -196.65 c 0,-3.72 3.1,-6.71 6.82,-6.71 h 175.65 c 3.77,0 6.87,2.99 6.87,6.71 v 528.77 c 0,3.75 -3.1,6.74 -6.87,6.74",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2429.99,1883.79 h -618.26 c -3.72,0 -6.71,-2.75 -6.71,-6.02 v -149.68 c 0,-3.51 2.99,-6.14 6.71,-6.14 h 618.26 c 3.85,0 6.85,2.63 6.85,6.14 v 149.68 c 0,3.27 -3,6.02 -6.85,6.02",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2429.99,1616.54 h -618.26 c -3.72,0 -6.71,-2.83 -6.71,-6.24 v -149.67 c 0,-3.36 2.99,-6.04 6.71,-6.04 h 618.26 c 3.85,0 6.85,2.68 6.85,6.04 v 149.67 c 0,3.41 -3,6.24 -6.85,6.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1325.02,3738.11 h 85.85 v -191.84 h -43.46 v 39.21 c -7.95,-27.02 -24.91,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.02,96.98 90.61,96.98 66.78,0 86.39,-37.09 86.39,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.09 v -192.91 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.61,0 29.67,11.13 29.67,34.45 v 63.59 h -28.61 v 47.7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1442.68,3905.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1610.7,3623.64 v 48.22 h 56.17 v -49.29 c 0,-20.13 9,-31.78 29.67,-31.78 19.08,0 27.56,12.71 27.56,31.78 v 13.79 c 0,20.66 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.92 v 12.18 c 0,44.52 25.97,78.96 84.8,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.15 h -55.12 v 31.27 c 0,20.66 -9.54,30.73 -28.62,30.73 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.79 28.62,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.51,-84.26 -87.97,-84.26 -61.48,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1813.15,3639.01 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.77,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.15,34.98 -21.73,0 -30.73,-15.37 -30.73,-37.09 v -192.91 c 0,-21.72 9,-37.09 30.73,-37.09 21.73,0 29.15,13.78 29.15,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2137.49,3704.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2230.26,3905.56 h 60.41 v -310.01 h 72.07 v -49.28 h -132.48 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2387.66,3905.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2556.2,3639.01 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.78,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.43,34.98 -29.14,34.98 -21.73,0 -30.75,-15.37 -30.75,-37.09 v -192.91 c 0,-21.72 9.02,-37.09 30.75,-37.09 21.71,0 29.14,13.78 29.14,34.98 v 66.24 h 55.11 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2880.55,3704.72 h -58.29 v -158.45 h -60.42 v 359.29 h 60.42 v -152.08 h 58.29 v 152.08 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2966.42,3905.56 h 160.56 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3152.43,3905.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.89 v -48.76 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3386.69,3856.28 v -111.82 h 20.14 c 20.66,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.02,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3523.97,3758.77 h 84.78 v -48.75 h -84.78 v 48.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1325.02,3238.1 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.02 -24.91,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.02,96.98 90.61,96.98 66.78,0 86.39,-37.09 86.39,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.09 v -192.9 c 0,-21.73 9.01,-37.1 29.68,-37.1 19.61,0 29.67,11.13 29.67,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1442.68,3405.56 h 60.42 v -310.01 h 72.07 v -49.28 h -132.49 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1600.09,3405.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1773.92,3405.56 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1866.67,3139.01 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.78,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.12 v 47.16 c 0,22.26 -7.42,34.98 -29.14,34.98 -21.72,0 -30.74,-15.37 -30.74,-37.09 v -192.9 c 0,-21.73 9.02,-37.1 30.74,-37.1 21.72,0 29.14,13.78 29.14,34.98 v 66.24 h 55.12 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2191.01,3204.72 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.08 h 58.29 v 152.08 h 60.95 v -359.29 h -60.95 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2402.48,3204.72 h -58.29 v -158.45 h -60.42 v 359.29 h 60.42 v -152.08 h 58.29 v 152.08 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2495.24,3405.56 h 144.15 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2669.07,3405.56 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2754.93,3405.56 h 160.57 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe05);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-05.5bda30f9109e8babe87dcc2cd6fd6bfe.svg";
export { ForwardRef as ReactComponent };